import React from "react";

const PublicationTypes = ({ type, type_short }) => {
  let first_year = Object.keys(type)[0];
  let type_name = type[first_year]["publications"][0]["type"];

  function _scrollTo(selector, yOffset) {
    const el = document.getElementById(selector);
    const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
    window.scrollTo({ top: y, behavior: "smooth" });
  }

  const handleClick = (event) => {
    event.preventDefault();
    let anchorTarget = event.target.dataset.scrollto;
    // Handle the sticky nav
    _scrollTo(anchorTarget, -100);
  };

  return (
    <div>
      <a
        data-scrollto={`pub${type_short}`}
        href="#"
        onClick={handleClick}
        aria-label={`Scroll to ${type_short}`}
      >
        {type_name}
      </a>
    </div>
  );
};
export default PublicationTypes;
